export default __webpack_public_path__ + "static/media/logo.b05fb5c7.png";